import { FormTemplate } from "components/modal/templates";
import React from "react";
import { apply, getItem } from "sources/books/drivers";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class CreateDriverModal extends FormTemplate {
    componentDidMount() {
        const initial = this.props.initialState ? this.props.initialState : {};
        const { id } = this.props;

        if (id) {
            getItem({ id }).then((data) => this.setState({ isLoading: false, isValid: true, ...initial, ...data }));
        } else {
            this.setState({ isLoading: false, isValid: true, ...initial });
        }
    }

    sendRequest = (stateData) => {
        return apply(stateData);
    };

    renderBodyInner = () => {
        const { config } = this.props;
        return (
            <Markup
                {...config}
                renderField={this.renderField}
                renderCheckbox={this.renderCheckbox}
                renderSelect={this.renderSelect}
            />
        );
    };
}

const ConfiguredModal = (props) => <CreateDriverModal {...props} config={config} initialState={initialState} />;

export default ConfiguredModal;
